<div class="avatar" [ngStyle]="{'width.px': size, 'height.px': size}">
    <img
    [src]="avatarSrc" alt="Avatar" [appImageFallback]="errorSrc">
</div>